/**
 * WHAT:
 *   Header component for TestTab with icon and title.
 *
 * WHY:
 *   Provides consistent header UI for the test tab.
 *
 * DOMAIN: Investments → Parqet → Test Tab → Components
 *
 * DEPENDENCIES:
 *   - Card component from UI library
 *   - TypeScript types (TestTabHeaderProps)
 *
 * RISKS:
 *   None - Simple presentational component
 */

import type { TestTabHeaderProps as TestTabHeaderProperties } from "../types";

import { type FC } from "react";

import { Card } from "@/components/ui";

/**
 * WHAT:
 *   Header component displaying TestTab title and icon.
 *
 * WHY:
 *   Centralizes header UI for better maintainability.
 *
 * @returns {JSX.Element} The TestTabHeader component
 *
 */
export const TestTabHeader: FC<TestTabHeaderProperties> = () => {
  return (
    <Card
      className="bg-slate-700/30 border-slate-600/50 shadow-tracq-card"
      padding="lg"
      variant="elevated"
    >
      <div className="flex items-center gap-3">
        <div className="p-2 bg-tracq-bright-blue/20 rounded-lg">
          <svg className="w-6 h-6 text-tracq-bright-blue" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white">PDF Parser Test</h1>
          <p className="text-slate-400">Test and debug PDF parsing functionality</p>
        </div>
      </div>
    </Card>
  );
};
